import { ConditionGroup } from "@/schema"

import { DataTableEntityType, ViewColumn } from "./view-column"

export type { DataTableEntityType }

export type DataViewType =
  | "default"
  | "person"
  | "review_manager"
  | "upcoming_meeting"
  | "processed_meeting"
  | "project_kanban"
  | "service_board"

export interface ViewSort {
  id?: string
  field?: string
  direction?: "asc" | "desc"
  sort_order?: number
}

export interface DataView {
  id?: string
  book_ids?: string[]
  group_by?: string | null
  project_template_id?: string | null
  company_wide?: boolean
  entity_type: DataTableEntityType
  name: string | null
  sort_order: number | null
  view_type: DataViewType
  condition_group: ConditionGroup
  view_columns: ViewColumn[]
  view_sorts: ViewSort[]
  created_at?: string
  updated_at?: string
  in_flight_count?: number
}

export const EmptyDataView: DataView = {
  book_ids: [],
  company_wide: false,
  entity_type: "client",
  name: "",
  sort_order: 0,
  view_type: "default",
  condition_group: { combinator: "and", conditions: [] },
  view_columns: [],
  view_sorts: [],
}
